import React, { useState } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import axios from "axios";
import {
  Button,
  ModalFooter,
  Modal,
  Alert,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { EditPlatform } from "./EditPlatform";
import {
  settingActions,
  msgActions,
  loaderMaskActions,
} from "../../../../redux/actions";
import { handleErrors } from "../../../../utils";

const INITIAL_PLATFORM_VALUES = {
  platformId: "",
  name: "",
  colorHex: "#4A4A4A",
  isPlatform: true,
  description: "",
};

function Platforms({
  user,
  subUser,
  isSubUser,
  userLDAPUserRights,
  platforms,
  translate,
  dispatch,
}) {
  const [showEditPlatform, setShowEditPlatform] = useState(false);
  const [editPlatformModalHeader, setEditPlatformModalHeader] = useState("");
  const [platformInitialValues, setPlatformInitialValues] = useState(
    INITIAL_PLATFORM_VALUES
  );
  const [addNewPlatform, setAddNewPlatform] = useState(false);
  const [confirmDeletePlatformModal, setConfirmDeletePlatformModal] =
    useState(false);
  const [platformToRemove, setPlatformToRemove] = useState(null);

  const generatePlatformGrid = () => {
    return (
      <table className="table" style={{ display: "table" }}>
        <thead>
          <tr>
            <th>Platform ID</th>
            <th>Visible name</th>
            <th>Platform?</th>
            <th>Color</th>
            <th>Description</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {(platforms || []).map((item, index) => (
            <tr key={item.platformId}>
              <td>{item.platformId}</td>
              <td>{item.name}</td>
              <td>{item.isPlatform ? "Yes" : "No"}</td>
              <td>
                <div
                  className="color-rec-container"
                  style={{
                    background: `${item.colorHex}`,
                  }}
                />
              </td>
              <td>{item.description}</td>
              <td style={{ display: "flex" }}>
                <button
                  disabled={
                    !(userLDAPUserRights && userLDAPUserRights.IsNTTAdmin)
                  }
                  style={{ padding: "0 5px" }}
                  className="add-issue-btn"
                  onClick={() => editPlatform(item)}
                >
                  <i className="fa fa-edit" />
                </button>
                <button
                  disabled={
                    !(userLDAPUserRights && userLDAPUserRights.IsNTTAdmin)
                  }
                  style={{ padding: "0 5px" }}
                  className="add-issue-btn"
                  onClick={() => handleRemovePlatform(item)}
                >
                  <i className="fa fa-times" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const handleAddNewPlatform = () => {
    setShowEditPlatform(true);
    setAddNewPlatform(true);
    setPlatformInitialValues({
      ...INITIAL_PLATFORM_VALUES,
    });
    setEditPlatformModalHeader(translate("Add New Platform"));
  };

  const editPlatform = (item) => {
    setShowEditPlatform(true);
    setAddNewPlatform(false);
    setPlatformInitialValues({
      ...item,
    });
    setEditPlatformModalHeader(translate("Edit Platform"));
  };

  const toggleEditPlatformModal = () => setShowEditPlatform(!showEditPlatform);

  const handleEditPlatformSubmit = async (values) => {
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { userId, timeZone } = currentUser || {};
    let PlatformData = {};
    if (!addNewPlatform) {
      // Updating
      PlatformData = {
        ...values,
        _id: platformInitialValues._id,
      };
    } else {
      PlatformData = { ...values };
    }
    const params = {
      TimeZone: timeZone,
      Username: userId,
      PlatformData,
    };
    try {
      dispatch(loaderMaskActions.show("Updating platforms..."));
      let data = await updatePlatform(params);
      dispatch(loaderMaskActions.hide(""));
      var _platforms = platforms.slice(0);
      var _index = _platforms.findIndex(({ _id }) => _id === data._id);
      if (_index === -1) {
        _platforms.push(data);
      } else {
        _platforms[_index] = data;
      }
      dispatch(settingActions.updatePlatformList(_platforms));
      dispatch(
        msgActions.success(
          "Updating platforms",
          "Platforms updated successfully"
        )
      );
      toggleEditPlatformModal();
    } catch (error) {
      dispatch(loaderMaskActions.hide(""));
      handleErrors(error, dispatch, "Updating platforms");
    }
  };

  const updatePlatform = async (params) => {
    const res = await axios.post("Configuration/platforms/addUpdate", params);
    const { Data, Errors } = res.data;
    if (Errors && Errors.length) {
      return Promise.reject(Errors[0]);
    }
    if (typeof Data === "object") {
      return Promise.resolve(Data);
    }
    return Promise.reject("Unknown Error");
  };

  const handleRemovePlatform = (platform) => {
    setConfirmDeletePlatformModal(true);
    setPlatformToRemove(platform);
  };

  const toggleConfirmDeletePlatformModal = () =>
    setConfirmDeletePlatformModal(!confirmDeletePlatformModal);

  const handleYesConfirmDeletePlatform = async () => {
    try {
      dispatch(loaderMaskActions.show("Deleting platforms..."));
      await performDeletePlatform({ Id: platformToRemove?._id });
      dispatch(loaderMaskActions.hide(""));
      var _platforms = platforms.slice(0);
      var _index = _platforms.findIndex(
        ({ _id }) => _id === platformToRemove?._id
      );
      if (_index > -1) {
        _platforms.splice(_index, 1);
      }
      dispatch(settingActions.updatePlatformList(_platforms));
      dispatch(
        msgActions.success(
          "Deleting platforms",
          "Platforms updated successfully"
        )
      );
      toggleConfirmDeletePlatformModal();
    } catch (error) {
      handleErrors(error, dispatch, "Deleting platforms");
      dispatch(loaderMaskActions.hide(""));
    }
  };

  const performDeletePlatform = async (params) => {
    let res = await axios.delete("Configuration/platforms/delete", { params });
    let { Data, Errors } = res.data;
    if (Errors && Errors.length) {
      return Promise.reject(Errors[0]);
    }
    if (Data) {
      return Promise.resolve(Data);
    }
    return Promise.reject("Unknown Error");
  };

  return (
    <>
      <div className="platform-container">
        <div className="row flex-nowrap justify-content-between align-items-center">
          <div className="col-4">
            <strong>{translate("Platforms")}</strong>
          </div>
          <div className="col-4 d-flex justify-content-end align-items-center">
            <Button
              disabled={!(userLDAPUserRights && userLDAPUserRights.IsNTTAdmin)}
              color="primary"
              size="sm"
              onClick={handleAddNewPlatform}
            >
              <span className="fa fa-plus" />
            </Button>
          </div>
        </div>
        <div className="channel-grid">{generatePlatformGrid()}</div>
      </div>
      <EditPlatform
        isOpen={showEditPlatform}
        toggleModal={toggleEditPlatformModal}
        modalHeader={editPlatformModalHeader}
        initialValues={{ ...platformInitialValues }}
        handleSubmit={handleEditPlatformSubmit}
      />
      <Modal
        isOpen={confirmDeletePlatformModal}
        toggle={toggleConfirmDeletePlatformModal}
      >
        <ModalHeader toggle={toggleConfirmDeletePlatformModal}>
          Remove Platform
        </ModalHeader>
        <ModalBody>
          <Alert color="danger">{translate("DeletePlatformConfirm")}</Alert>
        </ModalBody>
        <ModalFooter className="text-center">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={toggleConfirmDeletePlatformModal}
          >
            Cancel
          </button>
          <Button
            color="primary"
            className="EventSearchSubmit"
            style={{ marginLeft: "20px" }}
            onClick={handleYesConfirmDeletePlatform}
          >
            Remove
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  const {
    settings: { platforms },
    locale,
    authentication,
  } = state;
  const { user, subUser, isSubUser, userLDAPUserRights } = authentication;
  return {
    user,
    subUser,
    isSubUser,
    userLDAPUserRights,
    platforms,
    translate: getTranslate(locale),
  };
}

const connectedPlatforms = connect(mapStateToProps)(Platforms);
export { connectedPlatforms as Platforms };
